// extracted by mini-css-extract-plugin
module.exports = {"InvoiceHistoryContainer":"InvoiceHistory_InvoiceHistoryContainer__1U35M","InvoiceHistoryTitle":"InvoiceHistory_InvoiceHistoryTitle__2wCCL"};